import {ChangeDetectionStrategy, Component, inject, Input} from '@angular/core';
import {Store} from '@ngrx/store';
import {Hold} from '@store/holds/holds.types';
import {HoldsActions} from '@store/holds/holds.actions';
import {HoldsSelectors} from '@store/holds/holds.selectors';
import {HoldStatusColumnComponent} from '@app/my-account/holds/table-column-components/hold-status-column.component';
import {OutlinedButtonComponent} from '@aviary/buttons/outlined-button/outlined-button.component';

@Component({
  selector: 'px-combined-hold-status-actions-column',
  host: {
    class: 'text-wrap',
  },
  template: `
    <div class="flex flex-col items-end gap-y-4">
      @if (showActions) {
        <mx-outlined-button startIcon="edit" tooltip="Edit Hold" [enabled]="editEnabled" (click)="editHoldClicked()"/>
      }

      <!-- Status -->
      <px-hold-status-column [hold]="hold"/>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [HoldStatusColumnComponent, OutlinedButtonComponent]
})
export class CombinedHoldStatusActionsColumnComponent {
  @Input({required: true}) public hold: Hold;
  @Input() public editEnabled: boolean;
  @Input() public showActions: boolean;
  private readonly store = inject(Store);
  public readonly selectors = HoldsSelectors.OnHold;

  public editHoldClicked(): void {
    this.store.dispatch(HoldsActions.showEditHold(this.hold));
  }
}
